import React, { Component } from 'react'

const NEWS_DATA = [
    {
        date: "2020.08.12",
        source: "Harper's BAZAAR",
        title: "台北豆花6家必吃名單 — DoDay豆日子入選推薦",
        excerpt: "Harper's Bazaar 精選台北六家必吃豆花店，豆日子以非基改有機黃豆與一甲子傳統工藝入選推薦名單。",
        url: "https://www.harpersbazaar.com/tw/culture/lifestyle/g33736272/taipei-douhua/"
    },
    {
        date: "2021.04.08",
        source: "UP Media",
        title: "新鮮手作！木柵「DoDay Pro 豆日子」進駐信義區微風超市",
        excerpt: "DoDay Pro豆日子進駐微風南山，新增獨家芋頭配料，從木柵街邊小店到大台北必吃豆花甜品店。",
        url: "https://www.upmedia.mg/news_info.php?Type=5&SerialNo=110389"
    },
    {
        date: "2021.04.07",
        source: "China Times",
        title: "米其林主廚超市引進明星甜品店 DoDay Pro 豆日子進駐微風超市南山",
        excerpt: "被譽為「米其林主廚超市」的微風南山引進豆日子，採用價格四倍的有機黃豆，打造頂級豆花體驗。",
        url: "https://www.chinatimes.com/realtimenews/20210407004050-260405"
    },
    {
        date: "2021.04.06",
        source: "Marie Claire",
        title: "木柵北歐風豆花店《DoDay豆日子》開新店了！首度進駐微風南山",
        excerpt: "除了招牌豆花，還有現打綠豆沙豆漿、紅豆豆漿、芋頭豆漿等全新飲品，以及瓶裝純豆漿外帶。",
        url: "https://www.marieclaire.com.tw/lifestyle/taste/56276"
    },
    {
        date: "2021.04.06",
        source: "WalkerLand",
        title: "時尚豆花的老味道！街邊名店「DoDay豆日子」進駐微風南山B1",
        excerpt: "非基改有機黃豆搭配70年老師傅工藝精神，挑戰最強美食街豆花稱號。開幕大獎100天免費甜品！",
        url: "https://www.walkerland.com.tw/subject/view/296164"
    },
    {
        date: "2021.10.14",
        source: "Food Blog",
        title: "DoDay 豆日子豆花甜品店 — 下午的豆漿 豆花的美好時光",
        excerpt: "口味甘甜，沒有那種澀澀的口感。簡約風格讓人感覺起來相當的舒服，芋圓Q彈有嚼勁。",
        url: "https://twpang.com.tw/blog/post/doday_mucha"
    },
    {
        date: "2020.08",
        source: "Medium",
        title: "北歐風文青豆花店與高科技的驚喜邂逅 — 豆日子DoDay",
        excerpt: "建中科學班同學傳承阿公六十年豆花工藝，結合北歐風設計與LINE數位集點，一碗只要50元的高CP值體驗。",
        url: "https://debbyhsu725.medium.com/%E5%8C%97%E6%AD%90%E9%A2%A8%E6%96%87%E9%9D%92%E8%B1%86%E8%8A%B1%E5%BA%97%E8%88%87%E9%AB%98%E7%A7%91%E6%8A%80%E7%9A%84%E9%A9%9A%E5%96%9C%E9%82%82%E9%80%85-%E8%B1%86%E6%97%A5%E5%AD%90doday-4d4171ebf9c4"
    }
];

class NewsSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAll: false
        };
        this.sectionRef = React.createRef();
        this.cardsRef = [];
    }

    componentDidMount() {
        this.setupObserver();
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.showAll && this.state.showAll) {
            this.setupObserver();
        }
    }

    setupObserver() {
        if (this.observer) this.observer.disconnect();

        if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            entry.target.classList.add('visible');
                            this.observer.unobserve(entry.target);
                        }
                    });
                },
                { threshold: 0.05, rootMargin: '50px 0px 50px 0px' }
            );
            this.cardsRef.forEach(card => {
                if (card) this.observer.observe(card);
            });
        } else {
            this.cardsRef.forEach(card => {
                if (card) card.classList.add('visible');
            });
        }
    }

    componentWillUnmount() {
        if (this.observer) this.observer.disconnect();
    }

    render() {
        var self = this;
        var displayData = this.state.showAll ? NEWS_DATA : NEWS_DATA.slice(0, 3);

        return (
            <section className="news_section">
                <div className="section_header">
                    <span className="section_label">Media Coverage</span>
                    <h2 className="section_title">媒體報導</h2>
                </div>
                <div className="news_grid">
                    {displayData.map(function(item, index) {
                        return (
                            <a
                                key={index}
                                href={item.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="news_card reveal"
                                ref={function(el) { self.cardsRef[index] = el; }}
                                style={{ transitionDelay: (index * 0.1) + 's' }}
                            >
                                <div className="news_card_body">
                                    <span className="news_card_date">{item.date}</span>
                                    <span className="news_card_source">{item.source}</span>
                                    <h3 className="news_card_title">{item.title}</h3>
                                    <p className="news_card_excerpt">{item.excerpt}</p>
                                    <span className="news_card_link">查看更多</span>
                                </div>
                            </a>
                        );
                    })}
                </div>
                {!this.state.showAll && (
                    <div className="news_show_more">
                        <button
                            className="news_show_more_btn"
                            onClick={function() { self.setState({ showAll: true }); }}
                        >
                            查看更多報導 ↓
                        </button>
                    </div>
                )}
            </section>
        );
    }
}

export default NewsSection;
